<template>
	<div
		class="shippers"
	>
		<div class="shippers-list">
			<div
				v-for="logo in logos"
				:key="logo"
				class="col-md-2 text-center"
			>
				<img :src="require(`@/assets/${logo}`)">
			</div>
		</div>
		<div
			v-show="$route.name == 'notfound'"
			class="shippers-disclaimer"
		>
			<p>
				The pricing of your quote depends on weight, distance, and timing. Based on these variables, your quote can come out to $399. Learn <a href="https://www.mover-reviews.com/blog/how-to-calculate-moving-costs/">how to calculate moving costs</a> or <a href="https://www.mover-reviews.com/blog/how-to-save-money-moving-out-of-state/">how to save money when moving out of state</a>. You will be contacted directly by the moving companies that can service your route via email and phone. Top Moving ensures you are contacted by licensed and professional movers, but remember, it's best to do your own <a href="https://www.mover-reviews.com/">mover reviews</a> research when finally hiring a company to move you.
			</p>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			logos: [
				'allied-agent.png',
				'atlas-moving.png',
				'graebel.png',
				'national.png',
				'navl.png',
				'stevens.png',
			],
		};
	},
};
</script>

<style scoped lang="scss">
.shippers {
    margin: 0;
    background: white;
}

.shippers-list {
    max-width: 940px;
    margin: auto;
    display: block;
}

.shippers-disclaimer {
    display: block;
		font-size: 14px;
    margin: auto;
    max-width: 900px;

		ul {
			list-style: none;

			li {
				display: inline-block;
				margin: 0;
				padding: 0;

				&:not(:last-child)::after {
					content: "|";
					display: inline-block;
					padding: 0 10px;
				}
			}
		}
}

.shippers-list > * {
    margin: 20px auto;
    width: 16% !important;
    display: inline-block;

    img {
        width: 100%;
    }
}
</style>
